import { useEffect, RefObject, useCallback } from 'react';

const useSearchShortcut = (inputRef: RefObject<HTMLInputElement>) => {
  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    const isMac = navigator.platform?.toUpperCase().includes('MAC') ?? /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
    const modifier = isMac ? e.metaKey : e.ctrlKey;
    if (modifier && e.key === 'k') {
      e.preventDefault();
      inputRef.current?.focus();
    }
  }, [inputRef]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);
};

export default useSearchShortcut;
